const COLLECTION_GRID = document.querySelector('.mm-collection-grid');

Shopify.queryParams = {};
/**
 * Refresh the collection page with the provided filters.
 *
 * @param {string} url_filters - The URL parameters for the filters.
 */
function refreshCollectionPageWithFilters(url_filters, submitMobile = false) {
    let currentUrl = "//" + location.host + location.pathname;
    httpGet(currentUrl + "?" + url_filters).then(newPageString => {
        let newPageEl = document.createElement("DIV");
        newPageEl.innerHTML = newPageString;

        let newSection = newPageEl.querySelector(".mm-collection-grid");
        document.querySelector(".mm-collection-grid").innerHTML = newSection.innerHTML;

        if (window.innerWidth > 1024) {
            updateInnerLists(newPageEl);
        } else {
            updateMobileFilters(newPageEl);
        }

        updateProductsCount(newPageEl);
        updatePagination(newPageEl);
        updateFilterCounts(newPageEl);

        window.history.replaceState(null, document.title, currentUrl + "?" + url_filters);
        COLLECTION_GRID.classList.remove('mm-loading');
        startInitializingQuickAddElements();
    });
}

function updateInnerLists(newPageEl) {
    let innerLists = newPageEl.querySelectorAll(".filter-group-display__list");
    innerLists.forEach((innerList, index) => {
        document.querySelectorAll(".filter-group-display__list")[index].innerHTML = innerList.innerHTML;
    });
}

function updateMobileFilters(newPageEl) {
    let newFilters = newPageEl.querySelectorAll(".mm-mfc-dropdown-text");
    newFilters.forEach((newFilter, index) => {
        document.querySelectorAll(".mm-mfc-dropdown-text")[index].innerHTML = newFilter.innerHTML;
    });
    let newBtnMobileCount = newPageEl.querySelector("#applyFiltersButton");
    document.querySelector("#applyFiltersButton").innerHTML = newBtnMobileCount.innerHTML;
}

function updateProductsCount(newPageEl) {
    let newProductsCount = newPageEl.querySelector(".mm-header-collection-products-count");
    document.querySelector(".mm-header-collection-products-count").innerHTML = newProductsCount.innerHTML;
}

function updatePagination(newPageEl) {
    let newPagination = newPageEl.querySelector(".pagination-wrapper");
    if (newPagination) {
        document.querySelector(".pagination-wrapper").innerHTML = newPagination.innerHTML;
    } else {
        document.querySelector(".pagination-wrapper").innerHTML = '';
    }
}

function updateFilterCounts(newPageEl) {
    let newFilterGroups = newPageEl.querySelectorAll('.filter-group');
    newFilterGroups.forEach((newFilterGroup, index) => {
        let newCountContainer = newFilterGroup.querySelector('.mm-flex.mm-gap-5.mm-align-center');
        let currentFilterGroup = document.querySelectorAll('.filter-group')[index];
        let currentCountContainer = currentFilterGroup.querySelector('.mm-flex.mm-gap-5.mm-align-center');

        if (newCountContainer && currentCountContainer) {
            currentCountContainer.innerHTML = newCountContainer.innerHTML;
        } else if (!newCountContainer && currentCountContainer) {
            currentCountContainer.innerHTML = ''; // Clear the count if no new count exists
        } else if (newCountContainer && !currentCountContainer) {
            let filterPill = currentFilterGroup.querySelector('.filter-pill');
            filterPill.innerHTML += `
                <span class="mm-flex mm-gap-5 mm-align-center">
                    ${newCountContainer.innerHTML}
                </span>`;
        }
    });
}

function httpGet(theUrl) {
    return new Promise((resolve, reject) => {
        let xmlHttp = new XMLHttpRequest();
        xmlHttp.open('GET', theUrl, true);
        xmlHttp.onload = function() {
            if (xmlHttp.status >= 200 && xmlHttp.status < 300) {
                resolve(xmlHttp.responseText);
            } else {
                reject(new Error('Request failed: ' + xmlHttp.statusText));
            }
        };
        xmlHttp.onerror = function() {
            reject(new Error('Network error'));
        };
        xmlHttp.send();
    });
}

function initializeQuickAddElements() {
    const quickAddElementsTesting = document.querySelectorAll('.mm-collection-grid .mm-product-card quick-add > button');
    const productCards = document.querySelectorAll('.mm-collection-grid .mm-product-card');

    if (quickAddElementsTesting.length == productCards.length) {
      const quickAddElements = document.querySelectorAll('quick-add');
        quickAddElements.forEach(el => {
            new QuickAdd(el);
        });
        return true;
    }
    return false;
}

function startInitializingQuickAddElements() {
    const intervalId = setInterval(() => {
        if (initializeQuickAddElements()) {
            clearInterval(intervalId);
        }
    }, 1000); // Relancer toutes les secondes
}


/**
 * Check for changes in the filter inputs and submit the form if changes are detected.
 */
let form = document.getElementById("collectionFacetsForm");

function checkForChanges() {
    var inputs = form.querySelectorAll('input');

    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            COLLECTION_GRID.classList.add('mm-loading');
            // mmInitSplide();
        });
    });
}

//checkForChanges();

function mmCollectionFilterChanged(clickedInput) {
  COLLECTION_GRID.classList.add('mm-loading');
  setTimeout(() => {
    fakeSubmitForm(clickedInput);
  }, "0");
}

// Avec le tri du prix au kilo
// function mmCollectionFilterChanged(clickedInput) {
//     COLLECTION_GRID.classList.add('mm-loading');
    
//     const selectedValue = clickedInput.value;
  
//     // Vérifie si le tri personnalisé est sélectionné
//     if (selectedValue === 'custom-rating') {
//       const currentUrl = new URL(window.location.href);
//       currentUrl.searchParams.set('sort_by', 'custom-rating');
//       window.location.href = currentUrl.href;
//     } else {
//       setTimeout(() => {
//         fakeSubmitForm(clickedInput);
//       }, 0);
//     }
//   }

/**
 * Adds an event listener to all elements with the class 'sort_by'.
 * When the value of a 'sort_by' element changes, it updates the sort_by query parameter
 * in the URL and reloads the page with the new sorting applied.
 */
document.querySelector('.sort_by').addEventListener('change', function(e) {
	var value = e.target.value;
	Shopify.queryParams.sort_by = value;
	location.search = new URLSearchParams(Shopify.queryParams).toString();
});

// Fermeture des pills
document.addEventListener('click', function(event) {
  if (window.innerWidth > 1024) {
      let openFilters = document.querySelectorAll('.filter-group[open]');

      openFilters.forEach(filter => {
          if (!filter.contains(event.target)) {
              filter.removeAttribute('open');
          }
      });
  }
});

/**
 * Serialize the form data and refresh the collection page with the filters.
 */
function fakeSubmitForm(clickedInput, submitMobile = false) {
  let form = clickedInput.closest('form.filter-form');
  let url_filters = new URLSearchParams(new FormData(form)).toString();
  refreshCollectionPageWithFilters(url_filters, submitMobile);
}

// Functions for handling mobile filter drawer
if (window.innerWidth < 1024) {
    const wrapperMobile = document.querySelector(".mm-mobile-facets-collection");
    const filtersContainer = document.querySelector(".filters-container");

    /**
     * Open the mobile filters drawer.
     */
    function mmOpenFiltersMobile() {
        wrapperMobile.classList.add('mm-open');
        filtersContainer.style.zIndex = "20";

        filtersContainer.style.zIndex = "20";

        document.querySelector('html').classList.add('stop-scrolling');
    }

    /**
     * Close the mobile filters drawer.
     */
    function mmCloseFiltersMobile() {
        wrapperMobile.classList.remove('mm-open');
        filtersContainer.style.removeProperty("z-index");

        document.querySelector('html').classList.remove('stop-scrolling');
    }

    /**
     * Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
     */
    function mmCheckDrawer() {
        var currentUrl = document.location.href.indexOf('?open_filters');
        if (currentUrl !== -1) {
            mmOpenFiltersMobile();
        }
    }


    /*Dropdonws filters */
    const facetsDropdown = document.querySelectorAll(".mm-mfc-dropdown-collapsible");
    let q;

    for (q = 0; q < facetsDropdown.length; q++) {
      facetsDropdown[q].addEventListener("click", function () {
        this.classList.toggle("active");

        const content = this.nextElementSibling;

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }

    /* Submit form mobile*/
    const drawerCtaMobile = document.getElementById("applyFiltersButton");
    drawerCtaMobile.addEventListener("click", function () {
      let submitMobile = true;
      fakeSubmitForm(submitMobile);
    });
}




// FILTRES DE POURCENTAGE



/*********************************************************************************************
 * Functions for handling price range sliders.
 */;
 const minRange = document.getElementById('min-percent-range');
 const maxRange = document.getElementById('max-percent-range');
 const sliderTrack = document.querySelector('.slider-track');
 const minRangeValue = document.querySelector('.price-min-value-change');
 const maxRangeValue = document.querySelector('.price-max-value-change');
 
 function updateRange() {
     const minValue = parseInt(minRange.value, 10);
     const maxValue = parseInt(maxRange.value, 10);
 
     // Met à jour les valeurs affichées
     minRangeValue.textContent = `${minValue}%`;
     maxRangeValue.textContent = `${maxValue}%`;
 
     // Calcule les pourcentages pour la piste
     const minPercent = (minValue / minRange.max) * 100;
     const maxPercent = (maxValue / maxRange.max) * 100;
 
     sliderTrack.style.background = `linear-gradient(to right, #ddd ${minPercent}%, var(--black-900) ${minPercent}%, var(--black-900) ${maxPercent}%, #ddd ${maxPercent}%)`;
 }
 
 minRange.addEventListener('input', function () {
     if (parseInt(minRange.value) > parseInt(maxRange.value) - 10) {
         minRange.value = maxRange.value - 10;
     }
     updateRange();
 });
 
 maxRange.addEventListener('input', function () {
     if (parseInt(maxRange.value) < parseInt(minRange.value) + 10) {
         maxRange.value = parseInt(minRange.value) + 10;
     }
     updateRange();
 });
 
 // Initialiser le slider
 updateRange();
